import React from "react"
import autobind from "class-autobind"
import { IScheduleDailyTimelineData, ISimpleTime } from "../../../models"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import TimelineItemMoveTimeTitle from "./TimelineItemMoveTimeTitle"
import TimelineItemQuickEditTime from "./TimelineItemQuickEditTime"
interface IProps {
	widthPerHour: number
	timelineBarHourLength: number
	coordinateTime: ISimpleTime
	timelineItem: IScheduleDailyTimelineData
	rowNumber: number
	orderNumber: number
	readonly: boolean
	timelineItemRenderElement(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): JSX.Element
	handleUpdateTimelineData(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): void
	checkValidateNewTimeline?(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): boolean
	handleShowPopup(popupX: number, popupY: number, rowNumber: number, orderNumber: number): void
	handleHidePopup(): void

	// allow to edit by Tab
	quickEditTime?: boolean
	handleSelectQuickEditTimeItem?(rowNumber: number, orderNumber: number): void
}
interface IState {
	showStartResizeCursor: boolean
	showEndResizeCursor: boolean
	startTimePositionX: number
	endTimePositionX: number
	mousePositionX: number
	mousePositionY: number
	isDragDroping: boolean
	isMoving: boolean
	isLeftResize: boolean
	isRightResize: boolean
}

export default class TimelineItem extends React.Component<IProps, IState> {
	private oldValidStartTimePositionX
	private oldValidEndTimePositionX
	private TimelineItemQuickEditTime
	constructor(props) {
		super(props)
		const startTimePositionX = scheduleHelper.getPositionSimpleTimeInTimeline(props.coordinateTime, props.widthPerHour, props.timelineItem.StartTime)
		const endTimePositionX = scheduleHelper.getPositionSimpleTimeInTimeline(props.coordinateTime, props.widthPerHour, props.timelineItem.EndTime)
		this.state = {
			showStartResizeCursor: false,
			showEndResizeCursor: false,
			startTimePositionX,
			endTimePositionX,
			isDragDroping: false,
			isMoving: false,
			mousePositionX: null,
			mousePositionY: null,
			isLeftResize: false,
			isRightResize: false,
		}
		autobind(this)
	}

	componentDidMount() {
		window.addEventListener("mousemove", this.handleMouseMoveInWindow)
		window.addEventListener("mouseup", this.handleMouseUpInWindow)
	}

	componentWillUnmount() {
		window.removeEventListener("mousemove", this.handleMouseMoveInWindow)
		window.removeEventListener("mouseup", this.handleMouseUpInWindow)
	}

	componentWillReceiveProps(nextProps: IProps) {
		if (this.props.widthPerHour !== nextProps.widthPerHour ||
			this.props.timelineItem.StartTime !== nextProps.timelineItem.StartTime ||
			this.props.timelineItem.EndTime !== nextProps.timelineItem.EndTime) {
			const startTimePositionX = scheduleHelper.getPositionSimpleTimeInTimeline(nextProps.coordinateTime, nextProps.widthPerHour, nextProps.timelineItem.StartTime)
			const endTimePositionX = scheduleHelper.getPositionSimpleTimeInTimeline(nextProps.coordinateTime, nextProps.widthPerHour, nextProps.timelineItem.EndTime)
			this.setState({ startTimePositionX, endTimePositionX })
		}
	}

	handleMouseUpInWindow() {
		if (this.state.isMoving || this.state.isLeftResize || this.state.isRightResize) {
			if (this.oldValidStartTimePositionX !== this.state.startTimePositionX || this.oldValidEndTimePositionX !== this.state.endTimePositionX) {
				const timelineItem = this.getTimelineItem()
				const isValidNewTimelineItem = this.props.checkValidateNewTimeline ?
					this.props.checkValidateNewTimeline(timelineItem, this.props.rowNumber, this.props.orderNumber) : true
				if (isValidNewTimelineItem) {
					this.props.handleUpdateTimelineData(timelineItem, this.props.rowNumber, this.props.orderNumber)
				}
				else {
					this.setState({ startTimePositionX: this.oldValidStartTimePositionX, endTimePositionX: this.oldValidEndTimePositionX })
				}
			}
		}
		else {
			this.props.handleSelectQuickEditTimeItem(null, null)
		}
		this.setState({ isMoving: false, isLeftResize: false, isRightResize: false, mousePositionX: null })
	}

	handleMouseMoveInWindow(e) {
		if (this.props.quickEditTime) return
		if (this.state.isLeftResize) {
			const startTimePositionX = this.state.startTimePositionX - (this.state.mousePositionX - e.clientX)
			this.setState({
				mousePositionX: e.clientX,
				startTimePositionX: startTimePositionX >= 0 && startTimePositionX <= this.state.endTimePositionX - this.props.widthPerHour / 2 ? startTimePositionX : this.state.startTimePositionX,
			})
		}
		if (this.state.isRightResize) {
			const endTimePositionX = this.state.endTimePositionX - (this.state.mousePositionX - e.clientX)
			const timelineWidth = this.props.widthPerHour * this.props.timelineBarHourLength
			this.setState({
				mousePositionX: e.clientX,
				endTimePositionX: endTimePositionX <= timelineWidth && endTimePositionX >= this.state.startTimePositionX + this.props.widthPerHour / 2 ? endTimePositionX : this.state.endTimePositionX,
			})
		}
		if (this.state.isMoving) {
			const startTimePositionX = this.state.startTimePositionX - (this.state.mousePositionX - e.clientX)
			const endTimePositionX = this.state.endTimePositionX - (this.state.mousePositionX - e.clientX)
			const timelineWidth = this.props.widthPerHour * this.props.timelineBarHourLength
			this.setState({
				mousePositionX: e.clientX,
				mousePositionY: e.clientY,
				startTimePositionX: startTimePositionX >= 0 && endTimePositionX <= timelineWidth ? startTimePositionX : this.state.startTimePositionX,
				endTimePositionX: startTimePositionX >= 0 && endTimePositionX <= timelineWidth ? endTimePositionX : this.state.endTimePositionX,
			})
		}
	}

	getTimelineItem(): IScheduleDailyTimelineData {
		return {
			StartTime: scheduleHelper.getSimpleTimeFromPositionX(this.props.coordinateTime, this.props.widthPerHour, this.state.startTimePositionX),
			EndTime: scheduleHelper.getSimpleTimeFromPositionX(this.props.coordinateTime, this.props.widthPerHour, this.state.endTimePositionX),
			Breaks: this.props.timelineItem.Breaks
		}
	}

	handleClickTimelineItem(e) {
		if (this.props.readonly || (this.props.timelineItem.PunchedIn && this.props.timelineItem.PunchedOut)) return
		if (e.nativeEvent.button === 2) {
			e.preventDefault()
			this.props.handleShowPopup(e.clientX, e.clientY, this.props.rowNumber, this.props.orderNumber)
		}
	}

	render() {
		return (
			<div
				style={{
					position: "absolute",
					height: 46,
					top: 2,
					left: this.state.startTimePositionX,
					width: this.state.endTimePositionX - this.state.startTimePositionX,
					cursor: (!this.props.readonly || !this.props.timelineItem.Used) && "pointer",
					backgroundColor: "rgb(224, 224, 224)"
				}}
				onMouseDown={(e) => {
					e.stopPropagation()
					if (this.props.readonly || this.props.timelineItem.Used || this.props.quickEditTime) return
					if (e.nativeEvent.button === 2) return
					this.props.handleHidePopup()
					this.oldValidStartTimePositionX = this.state.startTimePositionX
					this.oldValidEndTimePositionX = this.state.endTimePositionX
					this.setState({
						isMoving: true,
						mousePositionX: e.clientX,
						mousePositionY: e.clientY,
						showStartResizeCursor: false,
						showEndResizeCursor: false
					})
				}}
				onMouseMove={() => !this.props.readonly && !this.state.isMoving && !this.props.quickEditTime &&
					this.setState({
						showStartResizeCursor: !this.props.timelineItem.PunchedIn,
						showEndResizeCursor: !this.props.timelineItem.PunchedOut
					})
				}
				onMouseOut={() =>
					this.setState({
						showStartResizeCursor: false,
						showEndResizeCursor: false
					})
				}
				onClick={this.handleClickTimelineItem}
				onContextMenu={this.handleClickTimelineItem}
				onDoubleClick={() => this.props.handleSelectQuickEditTimeItem(this.props.rowNumber, this.props.orderNumber)}
			>
				{this.state.isMoving &&
					<TimelineItemMoveTimeTitle
						mousePositionX={this.state.mousePositionX}
						mousePositionY={this.state.mousePositionY}
						coordinateTime={this.props.coordinateTime}
						widthPerHour={this.props.widthPerHour}
						startTimePositionX={this.state.startTimePositionX}
						endTimePositionX={this.state.endTimePositionX}
					/>
				}
				<div
					style={{ width: 7, height: 46, left: 0, top: 0, cursor: (!this.props.readonly && !this.props.timelineItem.PunchedIn) && "e-resize", position: "absolute" }}
					onMouseDown={(e) => {
						if (this.props.readonly || this.props.timelineItem.PunchedIn) return
						if (e.nativeEvent.button === 2) return
						this.oldValidStartTimePositionX = this.state.startTimePositionX
						this.oldValidEndTimePositionX = this.state.endTimePositionX
						this.setState({ isLeftResize: true })
					}}
				>
					<div
						style={{
							width: 2, height: 24, float: "right", marginTop: 11,
							borderColor: "rgba(255, 255, 255, 0.5)", borderStyle: "solid",
							borderWidth: this.state.showStartResizeCursor ? "0 1px" : "0 0"
						}}
					/>
				</div>
				<div
					style={{ width: 7, height: 46, right: 0, top: 0, cursor: (!this.props.readonly && !this.props.timelineItem.PunchedOut) && "e-resize", position: "absolute" }}
					onMouseDown={(e) => {
						if (this.props.readonly || this.props.timelineItem.PunchedOut) return
						if (e.nativeEvent.button === 2) return
						this.oldValidStartTimePositionX = this.state.startTimePositionX
						this.oldValidEndTimePositionX = this.state.endTimePositionX
						this.setState({ isRightResize: true })
					}}
				>
					<div
						style={{
							width: 2, height: 24, marginTop: 11,
							borderColor: "rgba(255, 255, 255, 0.5)", borderStyle: "solid",
							borderWidth: this.state.showEndResizeCursor ? "0 1px" : "0 0"
						}} />
				</div>
				{this.props.timelineItemRenderElement(this.props.timelineItem, this.props.rowNumber, this.props.orderNumber)}
				{this.props.quickEditTime &&
					<TimelineItemQuickEditTime
						ref={i => this.TimelineItemQuickEditTime = i}
						leftCoordinate={this.props.timelineBarHourLength * this.props.widthPerHour - this.state.startTimePositionX >= 200}
						timelineItem={this.props.timelineItem}
					/>
				}
			</div>
		)
	}
}